(() => {
  'use strict';

  const GAS_API_URL =
    'https://script.google.com/macros/s/AKfycbzm1Sn-7_mj6uHKaobMNSwpyh2VLhNxBtP1rU--juPc4SJoNbSyXcSy5sMAG5F16KXK/exec';

  const WEEKDAYS = [
    'Mon.',
    'Tue.',
    'Wed.',
    'Thu.',
    'Fri.',
    'Sat.',
    'Sun.',
  ];

  /**
   * カレンダーを初期化する
   */
  async function initCalendar() {
    const roots = document.querySelectorAll(
      '[id^="zouroku-calendar-"]'
    );

    if (roots.length === 0) {
      return;
    }

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;

    for (const root of roots) {
      if (root.dataset.initialized === 'true') {
        continue;
      }

      root.dataset.initialized = 'true';

      await renderTwoMonths(
        root,
        year,
        month
      );
    }
  }

  /**
 * 今月と翌月を取得して表示する
 */
async function renderTwoMonths(
  root,
  year,
  month
) {
  showLoading(root);

  try {
    const months =
      await fetchCalendarData(
        year,
        month,
        2
      );

    console.log(
      '2か月分のカレンダー:',
      months
    );

    renderMonths(
      root,
      months
    );
  } catch (error) {
    console.error(
      'カレンダー取得エラー:',
      error
    );

    showError(
      root,
      error.message
    );
  }
}

/**
 * GASから複数月分のJSONを取得する
 */
async function fetchCalendarData(
  year,
  month,
  monthCount = 2
) {
  const url =
    new URL(GAS_API_URL);

  url.searchParams.set(
    'year',
    String(year)
  );

  url.searchParams.set(
    'month',
    String(month)
  );

  url.searchParams.set(
    'months',
    String(monthCount)
  );

  /*
   * 更新を必ず即時反映したい場合は残す。
   * ブラウザキャッシュを使いたい場合は削除可能。
   */
  url.searchParams.set(
    '_',
    String(Date.now())
  );

  const response =
    await fetch(
      url.toString(),
      {
        method: 'GET',
        cache: 'no-store',
      }
    );

  if (!response.ok) {
    throw new Error(
      `通信に失敗しました。HTTP ${response.status}`
    );
  }

  const json =
    await response.json();

  if (!json.ok) {
    throw new Error(
      json.error?.message ||
      'カレンダーデータを取得できませんでした。'
    );
  }

  if (
    !json.data ||
    !Array.isArray(
      json.data.months
    )
  ) {
    throw new Error(
      'APIの返却データの形式が正しくありません。'
    );
  }

  return json.data.months;
}

  /**
   * 複数月を描画する
   */
  function renderMonths(
    root,
    months
  ) {
    root.innerHTML = '';

    const monthsWrapper =
      document.createElement('div');

    monthsWrapper.className =
      'zouroku-calendar-months';

    months.forEach(
      (monthData) => {
        const monthCalendar =
          createMonthCalendar(
            monthData
          );

        monthsWrapper.appendChild(
          monthCalendar
        );
      }
    );

root.appendChild(
  monthsWrapper
);
/*
resizeCalendarCanvas();
*/
  }

  /**
   * 1か月分のカレンダーを作る
   */
  function createMonthCalendar(
    data
  ) {
    const monthElement =
      document.createElement(
        'section'
      );

    monthElement.className =
      'zouroku-calendar-month';

    const heading =
      document.createElement('h2');

    heading.className =
      'zouroku-calendar-month__heading';

    heading.innerHTML = `
      <span class="zouroku-calendar-month-number">
        ${data.month}
      </span>

      <span class="zouroku-calendar-month-year">
        ${data.year}
      </span>
    `;

    monthElement.appendChild(
      heading
    );

    const grid =
      document.createElement('div');

    grid.className =
      'zouroku-calendar-grid';

    WEEKDAYS.forEach(
      (weekday, index) => {
        const weekdayCell =
          document.createElement(
            'div'
          );

        weekdayCell.className =
          'zouroku-calendar-grid__weekday';

        if (index === 5) {
          weekdayCell.classList.add(
            'is-saturday'
          );
        }

        if (index === 6) {
          weekdayCell.classList.add(
            'is-sunday'
          );
        }

        weekdayCell.textContent =
          weekday;

        grid.appendChild(
          weekdayCell
        );
      }
    );

    for (
      let index = 0;
      index <
      Number(data.firstDayOffset);
      index += 1
    ) {
      grid.appendChild(
        createEmptyDayCell()
      );
    }

    for (
      let day = 1;
      day <= Number(data.lastDay);
      day += 1
    ) {
      const dayData =
        findDayData(
          data.days,
          day
        );

      const dayCell =
        createDayCell(
          data,
          day,
          dayData
        );

      grid.appendChild(
        dayCell
      );
    }

    const usedCellCount =
      Number(data.firstDayOffset) +
      Number(data.lastDay);

    const totalCellCount =
      usedCellCount <= 35
        ? 35
        : 42;

    const remainingCellCount =
      totalCellCount -
      usedCellCount;

    for (
      let index = 0;
      index < remainingCellCount;
      index += 1
    ) {
      grid.appendChild(
        createEmptyDayCell()
      );
    }

    monthElement.appendChild(
      grid
    );

    return monthElement;
  }

  /**
   * 日付セルを作る
   */
  function createDayCell(
    monthData,
    day,
    dayData
  ) {
    const dayCell =
      document.createElement('div');

    dayCell.className =
      'zouroku-calendar-grid__day';

    const weekdayIndex =
      (
        Number(
          monthData.firstDayOffset
        ) +
        day -
        1
      ) % 7;

    if (weekdayIndex === 5) {
      dayCell.classList.add(
        'is-saturday'
      );
    }

    if (weekdayIndex === 6) {
      dayCell.classList.add(
        'is-sunday'
      );
    }

    if (
      dayData &&
      dayData.isHoliday
    ) {
      dayCell.classList.add(
        'is-holiday'
      );
    }

    /**
     * 上段：日付＋営業時間
     */
    const topRow =
      document.createElement('div');

    topRow.className =
      'zouroku-calendar-grid__top-row';

    const dateNumber =
      document.createElement(
        'span'
      );

    dateNumber.className =
      'zouroku-calendar-grid__date';

    dateNumber.textContent =
      String(day);

    topRow.appendChild(
      dateNumber
    );

    if (
      dayData &&
      dayData.isOpen &&
      dayData.business
    ) {
      const business =
        dayData.business;

      dayCell.classList.add(
        'is-open'
      );

      const hours =
        document.createElement(
          'span'
        );

      hours.className =
        'zouroku-calendar-grid__hours';

      hours.textContent =
        formatBusinessHours(
          business
        );

      topRow.appendChild(
        hours
      );
    } else {
      dayCell.classList.add(
        'is-closed'
      );

      const closed =
        document.createElement(
          'span'
        );

      closed.className =
        'zouroku-calendar-grid__closed';

      closed.textContent =
        '休業日';

      topRow.appendChild(
        closed
      );
    }

    dayCell.appendChild(
      topRow
    );

    /**
     * お店番タイトル
     */
    const businessTitleArea =
      document.createElement('div');

    businessTitleArea.className =
      'zouroku-calendar-grid__business';

    if (
      dayData &&
      dayData.isOpen &&
      dayData.business
    ) {
      const title =
        document.createElement('p');

      title.className =
        'zouroku-calendar-grid__business-title';

      title.textContent =
        dayData.business.title ??
        dayData.business.staffName ??
        '';

      businessTitleArea.appendChild(
        title
      );
    }

    dayCell.appendChild(
      businessTitleArea
    );

    /**
     * イベント
     */
    const eventsArea =
      document.createElement('div');

    eventsArea.className =
      'zouroku-calendar-grid__events';

    if (
      dayData &&
      Array.isArray(
        dayData.events
      )
    ) {
      dayData.events
        .slice(0, 2)
        .forEach(
          (eventData) => {
            const eventButton =
              document.createElement(
                'button'
              );

            eventButton.type =
              'button';

            eventButton.className =
              'zouroku-calendar-event';

            const eventText =
              document.createElement(
                'span'
              );

            eventText.className =
              'zouroku-calendar-event__text';

            const time =
              eventData.startTime
                ? `${eventData.startTime}– `
                : '';

            eventText.textContent =
              `${time}${eventData.title || ''}`;

            eventButton.appendChild(
              eventText
            );

            eventButton.addEventListener(
              'click',
              () => {
                openEventModal(
                  eventData,
                  dayData.date
                );
              }
            );

            eventsArea.appendChild(
              eventButton
            );
          }
        );
    }

    dayCell.appendChild(
      eventsArea
    );

    return dayCell;
  }

  /**
   * イベント詳細モーダルを開く
   */
  function openEventModal(
    eventData,
    date
  ) {
    let modal =
      document.querySelector(
        '.zouroku-calendar-modal'
      );

    if (!modal) {
      modal =
        createEventModal();

      document.body.appendChild(
        modal
      );
    }

    const title =
      modal.querySelector(
        '.zouroku-calendar-modal__title'
      );

    const datetime =
      modal.querySelector(
        '.zouroku-calendar-modal__datetime'
      );

    const location =
      modal.querySelector(
        '.zouroku-calendar-modal__location'
      );

    const description =
      modal.querySelector(
        '.zouroku-calendar-modal__description'
      );

    title.textContent =
      eventData.title || '';

    datetime.textContent =
      formatEventDateTime(
        date,
        eventData
      );

    if (eventData.location) {
      location.textContent =
        eventData.location;

      location.hidden = false;
    } else {
      location.textContent = '';
      location.hidden = true;
    }

if (eventData.description) {
  description.innerHTML =
    sanitizeCalendarDescription(
      eventData.description
    );

  description.hidden = false;
} else {
  description.innerHTML = '';
  description.hidden = true;
}

    modal.hidden = false;

    document.body.classList.add(
      'zouroku-calendar-modal-open'
    );

    const closeButton =
      modal.querySelector(
        '.zouroku-calendar-modal__close'
      );

    closeButton.focus();
  }

  /**
   * イベント詳細モーダルを閉じる
   */
  function closeEventModal() {
    const modal =
      document.querySelector(
        '.zouroku-calendar-modal'
      );

    if (!modal) {
      return;
    }

    modal.hidden = true;

    document.body.classList.remove(
      'zouroku-calendar-modal-open'
    );
  }

  /**
   * モーダルのHTMLを作る
   */
  function createEventModal() {
    const modal =
      document.createElement('div');

    modal.className =
      'zouroku-calendar-modal';

    modal.hidden = true;

    modal.innerHTML = `
      <div
        class="zouroku-calendar-modal__backdrop"
        data-calendar-modal-close
      ></div>

      <div
        class="zouroku-calendar-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="zouroku-calendar-modal-title"
      >
        <button
          type="button"
          class="zouroku-calendar-modal__close"
          aria-label="閉じる"
          data-calendar-modal-close
        >
          ×
        </button>

        <h3
          id="zouroku-calendar-modal-title"
          class="zouroku-calendar-modal__title"
        ></h3>

        <p
          class="zouroku-calendar-modal__datetime"
        ></p>

        <p
          class="zouroku-calendar-modal__location"
          hidden
        ></p>

        <div
          class="zouroku-calendar-modal__description"
          hidden
        ></div>
      </div>
    `;

modal
  .querySelectorAll(
    '[data-calendar-modal-close]'
  )
  .forEach((element) => {
    element.addEventListener(
      'click',
      () => {
        console.log(
          'close clicked',
          element
        );
        closeEventModal();
      }
    );
  });

return modal;
    
  }

  /**
   * モーダル用の日付・時間を整形
   */
  function formatEventDateTime(
    date,
    eventData
  ) {
    const dateObject =
      new Date(
        `${date}T00:00:00`
      );

    const dateText =
      new Intl.DateTimeFormat(
        'ja-JP',
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'short',
        }
      ).format(
        dateObject
      );

    if (eventData.isAllDay) {
      return dateText;
    }

    const startTime =
      eventData.startTime || '';

    const endTime =
      eventData.endTime || '';

    if (
      startTime &&
      endTime
    ) {
      return `${dateText} ${startTime}–${endTime}`;
    }

    if (startTime) {
      return `${dateText} ${startTime}–`;
    }

    return dateText;
  }


  /**
 * Googleカレンダーの説明HTMLを安全に整形する
 */
function sanitizeCalendarDescription(
  html
) {
  const template =
    document.createElement('template');

  template.innerHTML =
    String(html);

  const allowedTags =
    new Set([
      'BR',
      'P',
      'DIV',
      'SPAN',
      'STRONG',
      'B',
      'EM',
      'I',
      'UL',
      'OL',
      'LI',
      'A',
    ]);

  const walker =
    document.createTreeWalker(
      template.content,
      NodeFilter.SHOW_ELEMENT
    );

  const elements = [];

  while (walker.nextNode()) {
    elements.push(
      walker.currentNode
    );
  }

  elements.forEach(
    (element) => {
      if (
        !allowedTags.has(
          element.tagName
        )
      ) {
        element.replaceWith(
          document.createTextNode(
            element.textContent || ''
          )
        );

        return;
      }

      [
        ...element.attributes,
      ].forEach(
        (attribute) => {
          const name =
            attribute.name.toLowerCase();

          if (
            element.tagName === 'A' &&
            name === 'href'
          ) {
            const value =
              attribute.value.trim();

            if (
              !value.startsWith(
                'https://'
              ) &&
              !value.startsWith(
                'http://'
              )
            ) {
              element.removeAttribute(
                attribute.name
              );
            }

            return;
          }

          element.removeAttribute(
            attribute.name
          );
        }
      );

      if (
        element.tagName === 'A'
      ) {
        element.setAttribute(
          'target',
          '_blank'
        );

        element.setAttribute(
          'rel',
          'noopener noreferrer'
        );
      }
    }
  );

  return template.innerHTML;
}

  /**
   * 営業時間を整形する
   */
  function formatBusinessHours(
    business
  ) {
    const startTime =
      business.startTime || '';

    const endTime =
      business.endTime || '';

    if (
      startTime &&
      endTime
    ) {
      return `${startTime}–${endTime}`;
    }

    if (startTime) {
      return startTime;
    }

    return '';
  }

  /**
   * 空白セルを作る
   */
  function createEmptyDayCell() {
    const emptyCell =
      document.createElement('div');

    emptyCell.className =
      'zouroku-calendar-grid__day zouroku-calendar-grid__day--empty';

    /*
     * Shopifyテーマによって
     * 空要素が非表示になるのを防ぐ
     */
    emptyCell.textContent =
      '\u00A0';

    emptyCell.setAttribute(
      'aria-hidden',
      'true'
    );

    return emptyCell;
  }

  /**
   * 日付に対応するデータを探す
   */
  function findDayData(
    days,
    day
  ) {
    if (!Array.isArray(days)) {
      return null;
    }

    return (
      days.find(
        (dayData) =>
          Number(
            dayData.day
          ) === day
      ) || null
    );
  }

  /**
   * 読み込み中
   */
  function showLoading(root) {
    root.innerHTML =
      '<p class="zouroku-calendar-status">カレンダーを読み込んでいます…</p>';
  }

  /**
   * エラー表示
   */
  function showError(
    root,
    message
  ) {
    root.innerHTML = '';

    const box =
      document.createElement('div');

    box.className =
      'zouroku-calendar-error';

    const heading =
      document.createElement('p');

    heading.textContent =
      'カレンダーを読み込めませんでした。';

    const detail =
      document.createElement('p');

    detail.textContent =
      message;

    box.appendChild(
      heading
    );

    box.appendChild(
      detail
    );

    root.appendChild(
      box
    );
  }

  /**
   * 通常のページ読み込み
   */
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initCalendar
    );
  } else {
    initCalendar();
  }

  /**
   * Shopifyテーマエディタで
   * セクションが再描画された場合
   */
  document.addEventListener(
    'shopify:section:load',
    initCalendar
  );

  /**
 * ×ボタンまたは背景クリックでモーダルを閉じる
 */
document.addEventListener(
  'click',
  (event) => {
    const closeTarget =
      event.target.closest(
        '[data-calendar-modal-close]'
      );

    if (closeTarget) {
      closeEventModal();
    }
  }
);

/**
 * Escキーでモーダルを閉じる
 */
document.addEventListener(
  'keydown',
  (event) => {
    if (event.key === 'Escape') {
      closeEventModal();
    }
  }
);

/**
 * 680px未満ではカレンダー全体を縮小する
 */
/*
function resizeCalendarCanvas() {
  document
    .querySelectorAll(
      '.zouroku-calendar-responsive'
    )
    .forEach((wrapper) => {
      const canvas =
        wrapper.querySelector(
          '.zouroku-calendar-responsive__canvas'
        );

      if (!canvas) {
        return;
      }

      const baseWidth = 680;
      const availableWidth =
        wrapper.clientWidth;

      const scale =
        Math.min(
          1,
          availableWidth / baseWidth
        );

      canvas.style.transform =
        `scale(${scale})`;


      wrapper.style.height =
        `${canvas.offsetHeight * scale}px`;
    });
}

window.addEventListener(
  'resize',
  resizeCalendarCanvas
);

document.addEventListener(
  'DOMContentLoaded',
  resizeCalendarCanvas
);
*/

})();